// extracted by mini-css-extract-plugin
export var content = "content-and-toc-wrapper-module--content--d77bc";
export var contentWrapper = "content-and-toc-wrapper-module--contentWrapper--0fa69";